import { Field, FieldArray } from "formik"


const OutcomesSection = ({ formik }) => (
    <>
        <FieldArray name="outcomes">
            {({ push, remove }) => (
                <>
                    <div className="d-flex justify-content-between align-items-center mb-8">
                        <h3 className="mb-0">Outcomes</h3>
                        <button type="button" className="btn btn-sm btn-light-primary" onClick={() => push()}>Add Outcome</button>
                    </div>
                    {formik.values.outcomes.length > 0 && formik.values.outcomes.map((_, i) => (
                        <div key={i} className="d-flex align-items-center mb-4">
                            <Field name={`outcomes.${i}`} className="form-control flex-fill me-4" placeholder="Outcome" />
                            <div>
                                <button type="button" className="btn btn-sm btn-light-danger" onClick={() => remove(i)}>Remove</button>
                            </div>
                        </div>
                    ))}
                </>
            )}
        </FieldArray>
    </>
)

export default OutcomesSection